import { IApplicationState, TCardId } from '../../../../types/types';
import { ICardAssignee } from '../../cardAssignee/types';

export const getCardAssignee = (
    state: IApplicationState,
    cardId: TCardId
): ICardAssignee => {
    return state.model.cardAssignees && state.model.cardAssignees[cardId];
}
